import React from 'react';
import { Icon, IconProps } from '@frontend/design-system';

export const FacebookIcon: React.FC<React.PropsWithChildren<IconProps>> = (props) => (
  <Icon size={24} {...props} viewBox='0 0 24 24'>
    <path fill='#fff' fillRule='evenodd' d='M0 0h24v24H0V0z' clipRule='evenodd' />,
    <path
      fill='#1877F2'
      fillRule='evenodd'
      d='M24 12.072C24 5.404 18.625-.002 11.997-.002c-6.627 0-12 5.406-12 12.074C-.002 18.1 4.386 23.094 10.123 24v-8.437H7.076v-3.49h3.047v-2.66c0-3.026 1.792-4.697 4.533-4.697 1.313 0 2.686.236 2.686.236v2.97H15.83c-1.49 0-1.956.932-1.956 1.886v2.265h3.329l-.532 3.49h-2.797V24C19.611 23.094 24 18.1 24 12.072z'
      clipRule='evenodd'
    />
  </Icon>
);
